export default "__VITE_ASSET__CycxFyxB__"